var MAKE_UMTAUSCH_WEBHOOK = 'https://hook.eu1.make.com/dmlg82uh05pqd6eg4lnfy3lofnmv9jc5';
var MAKE_RETOUR_WEBHOOK = 'https://hook.eu1.make.com/6l0yctlhl1o66remisxvbgaahgx7vwp2';
var MAKE_FEEDBACK_WEBHOOK = 'https://hook.eu1.make.com/einmn016u0lwc8md2yi6qhslajqdhkdk';
var MAKE_CASHBACK_WEBHOOK = 'https://hook.eu1.make.com/flat9sciv33bysa9a1t3lr82rpsmvx7k';

// ——— POP-UP FUNCTIES (globaal, vroeg geladen) ———
function bellunaShowPopup(id) {
  document.querySelectorAll('.belluna-overlay').forEach(function(el) {
    el.classList.remove('active');
  });
  var popup = document.getElementById(id);
  if (popup) popup.classList.add('active');
}

function bellunaClosePopup() {
  document.querySelectorAll('.belluna-overlay').forEach(function(el) {
    el.classList.remove('active');
  });
}

function closePopup() {
  bellunaClosePopup();
}

// Delegatie voor alle sluitknoppen via class
document.addEventListener('click', function(e) {
  if (e.target && e.target.classList.contains('belluna-popup-btn-secondary')) {
    bellunaClosePopup();
  }
});

document.addEventListener('DOMContentLoaded', function() {

  // ——— CASHBACK BEVESTIGING ———
  if (document.querySelector('.belluna-confirm-box')) {
    var params = new URLSearchParams(window.location.search);
    var order = params.get('order') || '';
    var email = params.get('email') || '';
    var artikel = params.get('artikel') || '';

    if (order && email) {
      fetch(MAKE_CASHBACK_WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'cashback',
          date: new Date().toLocaleDateString('de-DE'),
          bestellnummer: order,
          email: email,
          artikel: artikel
        })
      });
    }
  }

  // ——— UMTAUSCHEN FORMULIER ———
  var selectRuil = document.getElementById('f-reden');
  if (selectRuil) {
    selectRuil.addEventListener('change', function() {
      var val = this.value;
      var wrap = document.getElementById('belluna-sonstiges-wrap');
      var tip = document.getElementById('belluna-reden-tip');

      if (wrap) wrap.style.display = val === 'sonstiges' ? 'block' : 'none';

      var tipTeksten = {
        'Kein ausreichender Halt': 'Fehlender Halt entsteht oft durch die falsche Größe. Probiere eine Größe kleiner oder schreib uns — wir helfen dir persönlich die richtige Größe zu finden.',
        'Tragekomfort nicht wie erwartet': 'Trageprobleme entstehen oft durch die falsche Größe. Probiere eine andere Größe oder schreib uns — wir helfen dir persönlich weiter.',
        'Träger rutschen ab': 'Rutschende Träger sind oft ein Zeichen, dass die Körbchengröße nicht stimmt. Probiere eine Größe kleiner oder schreib uns — wir finden gemeinsam die richtige Größe.',
        'Band zu eng': 'Wenn das Band zu eng ist, probiere eine Bandgröße größer. Nicht sicher? Schreib uns — wir helfen dir persönlich weiter.'
      };

      if (tip) {
        if (tipTeksten[val]) {
          tip.textContent = tipTeksten[val];
          tip.style.display = 'block';
        } else {
          tip.style.display = 'none';
        }
      }

      bellunaValidateRuil();
    });
  }

  var ruilInputs = document.querySelectorAll('#f-order, #f-email, #f-artikel, #f-ruil, #f-sonstiges');
  ruilInputs.forEach(function(input) {
    input.addEventListener('input', bellunaValidateRuil);
  });

  var btnRuil = document.getElementById('belluna-btn-submit');
  if (btnRuil) {
    btnRuil.addEventListener('click', function() {
      if (!btnRuil.classList.contains('active')) {
        document.getElementById('belluna-error-msg').style.display = 'block';
      } else {
        document.getElementById('belluna-error-msg').style.display = 'none';
        btnRuil.disabled = true;
        btnRuil.textContent = 'Wird gesendet...';

        var data = {
          type: 'umtausch',
          date: new Date().toLocaleDateString('de-DE'),
          bestellnummer: document.getElementById('f-order').value,
          email: document.getElementById('f-email').value,
          reden: document.getElementById('f-reden').value === 'sonstiges'
            ? document.getElementById('f-sonstiges').value
            : document.getElementById('f-reden').value,
          artikel_umtauschen: document.getElementById('f-artikel').value,
          artikel_erhalten: document.getElementById('f-ruil').value
        };

        fetch(MAKE_UMTAUSCH_WEBHOOK, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(function() {
          document.getElementById('belluna-form-wrap').style.display = 'none';
          document.getElementById('belluna-success').style.display = 'block';
        })
        .catch(function() {
          btnRuil.disabled = false;
          btnRuil.textContent = 'Umtausch beantragen';
          alert('Es ist ein Fehler aufgetreten. Bitte versuche es erneut.');
        });
      }
    });
  }

  // ——— RETOUR FORMULIER MET POP-UPS ———
  var orderInput = document.getElementById('r-order');
  var emailInput = document.getElementById('r-email');
  var artikelInput = document.getElementById('r-artikel');
  var redenSelect = document.getElementById('r-reden');
  var redenHint = document.getElementById('reden-hint');

  function checkFieldsForDropdown() {
    var order = orderInput ? orderInput.value.trim() : '';
    var email = emailInput ? emailInput.value.trim() : '';
    var artikel = artikelInput ? artikelInput.value.trim() : '';
    var allFilled = order && email && artikel;
    if (redenSelect) redenSelect.disabled = !allFilled;
    if (redenHint) redenHint.classList.toggle('visible', !allFilled);
  }

  if (orderInput) orderInput.addEventListener('input', checkFieldsForDropdown);
  if (emailInput) emailInput.addEventListener('input', checkFieldsForDropdown);
  if (artikelInput) artikelInput.addEventListener('input', checkFieldsForDropdown);

  if (redenSelect) {
    redenSelect.addEventListener('change', function() {
      var val = this.value;
      var wrap = document.getElementById('retour-sonstiges-wrap');
      if (wrap) wrap.style.display = val === 'sonstiges' ? 'block' : 'none';

      if (val === 'Zu groß' || val === 'Zu klein') {
        bellunaShowPopup('popup-size');
      } else if (val === 'Falsche Farbe') {
        bellunaShowPopup('popup-farbe');
      } else if (
        val === 'Kein ausreichender Halt' ||
        val === 'Tragekomfort nicht wie erwartet' ||
        val === 'Träger rutschen ab' ||
        val === 'Band zu eng'
      ) {
        bellunaShowPopup('popup-comfort');
      } else if (val === 'Qualität entspricht nicht den Erwartungen') {
        bellunaShowPopup('popup-kwaliteit');
      }

      bellunaValidateRetour();
    });
  }

  // Cashback knop
  var cashbackBtn = document.getElementById('cashback-btn');
  if (cashbackBtn) {
    cashbackBtn.addEventListener('click', function() {
      var order = orderInput ? orderInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var artikel = artikelInput ? artikelInput.value.trim() : '';
      bellunaClosePopup();
      window.location.href = '/pages/cashback-bevestigung'
        + '?order=' + encodeURIComponent(order)
        + '&email=' + encodeURIComponent(email)
        + '&artikel=' + encodeURIComponent(artikel);
    });
  }

  // Retour submit knop
  var btnRetour = document.getElementById('retour-btn-submit');
  if (btnRetour) {
    btnRetour.addEventListener('click', function() {
      if (!btnRetour.classList.contains('active')) {
        document.getElementById('retour-error-msg').style.display = 'block';
      } else {
        document.getElementById('retour-error-msg').style.display = 'none';
        btnRetour.disabled = true;
        btnRetour.textContent = 'Wird gesendet...';

        var data = {
          type: 'retour',
          date: new Date().toLocaleDateString('de-DE'),
          bestellnummer: document.getElementById('r-order').value,
          email: document.getElementById('r-email').value,
          reden: document.getElementById('r-reden').value === 'sonstiges'
            ? document.getElementById('r-sonstiges').value
            : document.getElementById('r-reden').value,
          artikel_zuruecksenden: document.getElementById('r-artikel').value,
          retourfee_akzeptiert: 'Yes'
        };

        fetch(MAKE_RETOUR_WEBHOOK, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(function() {
          document.getElementById('retour-form-wrap').style.display = 'none';
          document.getElementById('retour-success').style.display = 'block';
        })
        .catch(function() {
          btnRetour.disabled = false;
          btnRetour.textContent = 'Rücksendung beantragen';
          alert('Es ist ein Fehler aufgetreten. Bitte versuche es erneut.');
        });
      }
    });
  }

  var retourInputs = document.querySelectorAll('#r-order, #r-email, #r-artikel, #r-sonstiges');
  retourInputs.forEach(function(input) {
    input.addEventListener('input', bellunaValidateRetour);
  });

  var akkoord = document.getElementById('r-akkoord');
  if (akkoord) akkoord.addEventListener('change', bellunaValidateRetour);

  // ——— FEEDBACK FORMULIER ———
  var fbInputs = document.querySelectorAll('#fb-naam, #fb-email, #fb-feedback');
  fbInputs.forEach(function(input) {
    input.addEventListener('input', bellunaValidateFeedback);
  });

  var btnFb = document.getElementById('fb-btn-submit');
  if (btnFb) {
    btnFb.addEventListener('click', function() {
      if (!btnFb.classList.contains('active')) {
        document.getElementById('fb-error-msg').style.display = 'block';
      } else {
        document.getElementById('fb-error-msg').style.display = 'none';
        btnFb.disabled = true;
        btnFb.textContent = 'Wird gesendet...';

        var data = {
          type: 'feedback',
          date: new Date().toLocaleDateString('de-DE'),
          naam: document.getElementById('fb-naam').value,
          email: document.getElementById('fb-email').value,
          feedback: document.getElementById('fb-feedback').value
        };

        fetch(MAKE_FEEDBACK_WEBHOOK, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(function() {
          document.getElementById('feedback-form-wrap').style.display = 'none';
          document.getElementById('fb-success').style.display = 'block';
        })
        .catch(function() {
          btnFb.disabled = false;
          btnFb.textContent = 'Feedback absenden';
          alert('Es ist ein Fehler aufgetreten. Bitte versuche es erneut.');
        });
      }
    });
  }

});

// ——— VALIDATIE FUNCTIES ———
function bellunaValidateRuil() {
  var order = document.getElementById('f-order') ? document.getElementById('f-order').value.trim() : '';
  var email = document.getElementById('f-email') ? document.getElementById('f-email').value.trim() : '';
  var reden = document.getElementById('f-reden') ? document.getElementById('f-reden').value : '';
  var artikel = document.getElementById('f-artikel') ? document.getElementById('f-artikel').value.trim() : '';
  var ruil = document.getElementById('f-ruil') ? document.getElementById('f-ruil').value.trim() : '';
  var sonstiges = document.getElementById('f-sonstiges') ? document.getElementById('f-sonstiges').value.trim() : '';
  var redenOk = reden !== '' && (reden !== 'sonstiges' || sonstiges.length >= 1);
  var ok = order && email && redenOk && artikel && ruil;
  var btn = document.getElementById('belluna-btn-submit');
  if (btn) btn.classList.toggle('active', !!ok);
}

function bellunaValidateRetour() {
  var order = document.getElementById('r-order') ? document.getElementById('r-order').value.trim() : '';
  var email = document.getElementById('r-email') ? document.getElementById('r-email').value.trim() : '';
  var reden = document.getElementById('r-reden') ? document.getElementById('r-reden').value : '';
  var artikel = document.getElementById('r-artikel') ? document.getElementById('r-artikel').value.trim() : '';
  var sonstiges = document.getElementById('r-sonstiges') ? document.getElementById('r-sonstiges').value.trim() : '';
  var akkoord = document.getElementById('r-akkoord') ? document.getElementById('r-akkoord').checked : false;
  var redenOk = reden !== '' && (reden !== 'sonstiges' || sonstiges.length >= 1);
  var ok = order && email && redenOk && artikel && akkoord;
  var btn = document.getElementById('retour-btn-submit');
  if (btn) btn.classList.toggle('active', !!ok);
}

function bellunaValidateFeedback() {
  var naam = document.getElementById('fb-naam') ? document.getElementById('fb-naam').value.trim() : '';
  var email = document.getElementById('fb-email') ? document.getElementById('fb-email').value.trim() : '';
  var feedback = document.getElementById('fb-feedback') ? document.getElementById('fb-feedback').value.trim() : '';
  var ok = naam && email && feedback;
  var btn = document.getElementById('fb-btn-submit');
  if (btn) btn.classList.toggle('active', !!ok);
}